if (!customElements.get('fr-payment-dialog')) {
  customElements.define('fr-payment-dialog', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.onClose = () => {
        if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
      };
      this.onBackdropClick = (event) => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right ||
            event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      };
      this.dialog.addEventListener('close', this.onClose);
      this.dialog.addEventListener('click', this.onBackdropClick);
    }
    openFrom(trigger) {
      if (!this.dialog || this.dialog.open) return;
      this.opener = trigger;
      this.dialog.showModal();
    }
    disconnectedCallback() {
      this.dialog?.removeEventListener('close', this.onClose);
      this.dialog?.removeEventListener('click', this.onBackdropClick);
      if (this.dialog?.open) this.dialog.close();
    }
  });
}


if (!customElements.get('fr-sticky-purchase')) {
  customElements.define('fr-sticky-purchase', class extends HTMLElement {
    connectedCallback() {
      const submit = this.closest('product-info')?.querySelector('.pd-main-product__detail__top .product-form__submit');
      if (submit) {
        this.visibilityObserver = new IntersectionObserver((entries) => {
          const visible = !entries[0].isIntersecting;
          this.classList.toggle('is-visible', visible);
          this.toggleAttribute('inert', !visible);
          this.setAttribute('aria-hidden', String(!visible));
        }, { threshold: 0.1 });
        this.visibilityObserver.observe(submit);
      }
      this.sizeObserver = new ResizeObserver(() => {
        const height = this.getBoundingClientRect().height;
        if (height) document.documentElement.style.setProperty('--fr-sticky-height', `${height}px`);
      });
      this.sizeObserver.observe(this);
    }
    disconnectedCallback() {
      this.visibilityObserver?.disconnect();
      this.sizeObserver?.disconnect();
    }
  });
}

// A section can request this asset more than once. Register one delegated listener.
if (!window.frProductControlsBound) {
  window.frProductControlsBound = true;
  document.addEventListener('click', (event) => {
    const features = event.target.closest('a.fr-product-features__more');
    if (features && !event.defaultPrevented && event.button === 0 &&
        !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      const href = features.getAttribute('href');
      const target = href?.startsWith('#') && document.getElementById(href.slice(1));
      if (target) {
        event.preventDefault();
        target.focus({ preventScroll: true });
        target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        if (window.location.hash !== href) window.history.pushState(null, '', href);
        return;
      }
    }
    const payment = event.target.closest('[data-payment-info-trigger]');
    if (payment) {
      const root = payment.closest('product-info') || document;
      const dialog = Array.from(root.querySelectorAll('dialog.fr-payment-dialog'))
        .find((item) => item.id === payment.getAttribute('aria-controls'));
      dialog?.closest('fr-payment-dialog')?.openFrom(payment);
    }
    const waitlist = event.target.closest('[data-waitlist-form]');
    if (waitlist?.dataset.waitlistForm) {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', waitlist.dataset.waitlistForm]);
    }
    const reviews = event.target.closest('[data-product-reviews]');
    if (reviews) {
      const target = document.querySelector('#looxReviews, .loox-reviews-default');
      if (!target) return; // Retain the native anchor; a deferred widget can still attach later.
      event.preventDefault();
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    }
  });
}
